module.exports = __webpack_public_path__ + "fonts/daily_promotion_image.png!static";